"use strict";
var cache_1 = require("./cache");
/**
 * Clears the chevrotain internal cache.
 * This should not be used in regular work flows, This is intended for
 * unique use cases for example: online playground where the a parser with the same name is initialized with
 * different implementations multiple times.
 */
function clearCache() {
    cache_1.clearCache();
}
exports.clearCache = clearCache;
//# sourceMappingURL=cache_public.js.map


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/node_modules/chevrotain/lib/src/parse/cache_public.js
// module id = 1798
// module chunks = 7